import { css } from "@emotion/css";
import { useState } from "react";

const DesignSystemTooltip: React.FC<{
  children: [React.ReactNode, React.ReactNode];
}> = (props) => {
  if (!(props.children instanceof Array)) {
    return null;
  }

  const [tooltipText, hoverText] = props.children;

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      className={css`
        display: inline-block;
      `}
    >
      <div
        className={css`
          position: absolute;
          right: 20px;
        `}
      >
        {showTooltip && (
          <div
            className={css`
              position: absolute;
              background: rgba(38, 38, 38, 0.95);
              color: #fff;
              padding: 8px 12px;
              border-radius: 8px;
              bottom: calc(100% + 3px);
              font-size: 14rem;
              width: max-content;
              right: 0px;
              height: max-content;
              max-height: 67px;
              overflow: auto;

              ::-webkit-scrollbar {
                position: absolute;
                width: 10px;
                right: 5px;
              }

              ::-webkit-scrollbar-track {
                border: 4px solid rgba(0, 0, 0, 0);
                border-radius: 5px;
              }

              ::-webkit-scrollbar-thumb {
                background-clip: padding-box;
                border: 4px solid rgba(0, 0, 0, 0);
                background-color: rgba(255, 255, 255, 0.2);
              }
            `}
          >
            {tooltipText}
          </div>
        )}
      </div>
      {showTooltip && (
        <span
          className={css`
            position: relative;
            margin-left: -8px;
            left: 50%;
            border-width: 4px;
            border-style: solid;
            border-color: rgba(38, 38, 38, 0.95) transparent transparent
              transparent;
          `}
        />
      )}
      {hoverText}
    </div>
  );
};

export default DesignSystemTooltip;
